<template>
    <v-container>
        <v-card elevation="1">
            <v-card-title>
                <v-btn
                    icon
                    small
                    class="mr-2"
                    color="secondary"
                    @click="$router.push('results')"
                >
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <h1>My Schools</h1>
                <v-spacer></v-spacer>
                <v-btn @click="print" color="primary" class="mr-2 no-print">
                    <v-icon>mdi-printer</v-icon>
                    Print
                </v-btn>
                <v-btn @click="exportCSV" color="secondary no-print">
                    <v-icon>mdi-download</v-icon>
                    MSC Application Tracker Export
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :items="this.$store.getters.selectedSchools"
                    :headers="table.headers"
                    :sort-desc.sync="table.sortDesc"
                    sort-by="percentage"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:item.level="{ item }">
                        {{ formatTier(item.level) }}
                    </template>
                    <template v-slot:item.percentage="{ item }">
                        <v-chip
                            class="ma-2"
                            :color="getAcceptanceColor(item.percentage)"
                            text-color="white"
                            v-if="item.percentage"
                        >
                            {{ item.percentage }}%
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import schoolService from '../services/SchoolService';
import { json2excel } from 'js2excel';

const tierOrder = [
    'International',
    'Osteopathic',
    'Low/Mid Tier',
    'Mid/High Tier',
    'High Tier',
    'Top Tier',
];

export default {
    name: 'MySchools',
    data: () => ({
        table: {
            sortDesc: false,
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                    sortable: true,
                },
                {
                    text: 'State',
                    value: 'state',
                    sortable: true,
                },
                {
                    text: 'Avg MCAT',
                    value: 'fy_mcat',
                    sortable: true,
                },
                {
                    text: 'Avg GPA',
                    value: 'fy_total_gpa',
                    sortable: true,
                },
                {
                    text: 'Avg Science GPA',
                    value: 'fy_science_gpa',
                    sortable: true,
                },
                {
                    text: 'Tier',
                    value: 'level',
                    sortable: true,
                    sort: (a, b) => {
                        if (tierOrder.indexOf(a) > tierOrder.indexOf(b))
                            return 1;
                        if (tierOrder.indexOf(a) < tierOrder.indexOf(b))
                            return -1;
                        return 0;
                    },
                },
                {
                    text: 'MSC Competitiveness Score',
                    value: 'msc',
                    sortable: true,
                },
                {
                    text: 'Public/Private',
                    value: 'type',
                    sortable: true,
                },
                {
                    text: 'Out of State Percentage',
                    value: 'percentage',
                    sortable: true,
                },
            ],
        },
        level: 0,
        finalScore: 0,
        singleSchoolID: null,
        showDialog: false,
    }),
    created() {
        this.$store.dispatch('loadFromSession');
        this.level = this.$store.getters.level;
        this.finalScore = this.$store.getters.finalScore;
    },
    methods: {
        formatTier(value) {
            if (value !== undefined) {
                return value.replace('Tier', '');
            }
        },
        getAcceptanceColor(percentage) {
            return schoolService.getAcceptanceColor(percentage);
        },
        getStateColor(schoolState) {
            return schoolService.getStateColor(
                schoolState,
                this.$store.getters.user.state
            );
        },

        print() {
            window.print();
        },

        exportCSV() {
            window.sessionStorage.setItem(
                'selectedSchools',
                JSON.stringify(this.$store.getters.selectedSchools)
            );
            let data = this.$store.getters.selectedSchools;

            for (let i = 0; i < data.length; i++) {
                const d = data[i];
                d.mddo = d.mddo.toUpperCase();
                d['AVG_MCAT'] = d.fy_mcat;
                d['AVG_GPA'] = d.fy_total_gpa;
                d['AVG_science_Gpa'] = d.fy_science_gpa;
                d['Tier'] = this.formatTier(d.level);

                delete d.id;
                delete d.state;
                delete d.level;
                delete d.percentage;
                delete d.type;
                delete d.fy_mcat;
                delete d.fy_total_gpa;
                delete d.fy_science_gpa;
                delete d.msc;
                delete d.accepted_in_state;
                delete d.accepted_out_state;
                delete d.pdr_competitiveness;
                delete d.fy_chemical_physical_foundations;
                delete d.fy_critical_analysis;
                delete d.fy_biological_biochemical_foundations;
                delete d.fy_psychology_social_biological_foundations;
            }

            json2excel({
                data,
                name: 'my-schools',
                formateDate: 'yyyy/mm/dd',
            });

            this.$store.state.selectedSchools = JSON.parse(
                window.sessionStorage.getItem('selectedSchools')
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.no-print {
    @media print {
        display: none;
    }
}
</style>
